module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.448c34a56d699c29117a.woff2";


//////////////////
// WEBPACK FOOTER
// D:/Projekte/AH-Wohnen - CRM/ace.Crm.AhWohnen.Portal/ace.CRM.AHWohnen.Portal/ace.CRM.AHWohnen.Portal/ace.CRM.AHWohnen.Portal.RestService/Apps/AAVSApp/src/Content/fonts/glyphicons-halflings-regular.woff2
// module id = ../../../../../src/Content/fonts/glyphicons-halflings-regular.woff2
// module chunks = styles